import gate from '@/api/axios';

/**
 * Получает уведомления
 * @async
 * @function fetchNotifications
 * @param {Object} payload
 * @param {Number} payload.referenceId
 * @param {Number} payload.offset
 * @returns {Promise}
 */
export const fetchNotifications = (payload) => gate.get('/notifications', {
  params: payload,
});

/**
 * Прочитать уведомления
 * @async
 * @function readNotifications
 * @param {Array} payload
 * @returns {Promise}
 */
export const readNotifications = (payload) => gate.post('/notifications/read', payload);

/**
 * Количество непрочитанных уведомлений
 * @async
 * @function unreadNotificationsCount
 * @param {Array} payload
 * @returns {Promise}
 */
export const unreadNotificationsCount = () => gate.get('/notifications/unreadCount');
